import React from "react";
import "./Toggle.css";

const Toggle = props => {
  return (
    <label className="switch">
      <input
        type="checkbox"
        value={props.value}
        checked={props.value}
        onChange={props.onChange}
      />
      <span className="slider round" />
    </label>
  );
};

export default Toggle;



// WEBPACK FOOTER //
// ./src/components/common/Toggle/Toggle.js